import {
  GET_EMPLOYEE,
  GET_EMPLOYEE_ONE,
  GET_EMPLOYEE_SUCCESS,
  GET_EMPLOYEE_FAIL,
  DELETE_EMPLOYEE,
  DELETE_EMPLOYEE_SUCCESS,
  DELETE_EMPLOYEE_FAIL,
  UPDATE_EMPLOYEE,
  UPDATE_EMPLOYEE_SUCCESS,
  UPDATE_EMPLOYEE_FAIL,
  ADD_NEW_EMPLOYEE,
  ADD_EMPLOYEE_SUCCESS,
  ADD_EMPLOYEE_FAIL,
  EMPLOYEE_LOADING,
  EMPLOYEE_RESET,
} from "./actionType";

export const resetEmployeeState = (actionType) => ({
  type: EMPLOYEE_RESET,
  payload: { actionType },
});

export const getEmployeeSuccess = (actionType, data) => ({
  type: GET_EMPLOYEE_SUCCESS,
  payload: { actionType, data },
});

export const getEmployeeFail = (actionType, error) => ({
  type: GET_EMPLOYEE_FAIL,
  payload: { actionType, error },
});

export const getEmployee = (data) => ({
  type: GET_EMPLOYEE,
  payload: data,
});

export const getEmployeeOne = (data) => ({
  type: GET_EMPLOYEE_ONE,
  payload: data,
});

export const getEmployeeLoading = () => ({
  type: EMPLOYEE_LOADING,
});

export const deleteEmployee = (data) => ({
  type: DELETE_EMPLOYEE,
  payload: data,
});

export const deleteEmployeeSuccess = (data) => ({
  type: DELETE_EMPLOYEE_SUCCESS,
  payload: data,
});

export const deleteEmployeeFail = (error) => ({
  type: DELETE_EMPLOYEE_FAIL,
  payload: error,
});

export const updateEmployee = (data) => ({
  type: UPDATE_EMPLOYEE,
  payload: data,
});

export const updateEmployeeFail = (error) => ({
  type: UPDATE_EMPLOYEE_FAIL,
  payload: error,
});

export const updateEmployeeSuccess = (data) => ({
  type: UPDATE_EMPLOYEE_SUCCESS,
  payload: data,
});

export const addNewEmployee = (data) => ({
  type: ADD_NEW_EMPLOYEE,
  payload: data,
});

export const addEmployeeSuccess = (data) => ({
  type: ADD_EMPLOYEE_SUCCESS,
  payload: data,
});

export const addEmployeeFail = (error) => ({
  type: ADD_EMPLOYEE_FAIL,
  payload: error,
});
